module.exports = __webpack_public_path__ + "assets/img/icon-9.2c29f00c.png";